import React, { useState } from 'react';
import Wizard from 'components/general/wizard/Wizard';
import Button from 'lj_shared/button/button';
import Icon, { Size } from 'components/general/icon/icon';
import ConfirmationModal from 'components/general/confirmation_modal/ConfirmationModal';

interface Props {
  jobId: string;
  jobTitle: string;
  jobCompanyId: number;  
  currentStep?: number;
  totalSteps?: number;
}

const Header: React.FC<Props> = ({
  jobId,
  jobTitle,
  jobCompanyId,
  currentStep: propCurrentStep,
  totalSteps: propTotalSteps,
}) => {
  const styles = require('./Header.module.scss');
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const currentStep = propCurrentStep !== undefined ? propCurrentStep : 1;
  const totalSteps = propTotalSteps !== undefined ? propTotalSteps : 1;

  const handleExit = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <header id="quick-apply-header" className={styles.container}>
        <div className={styles.content}>
          <div className={styles.topRow}>
            <h1 className={styles.title}>QUICK APPLY TO</h1>
            <Button
              isButton={true}
              onClick={() => setIsModalOpen(true)}
              otherClassesOnly={true}
              otherClasses={styles.closeButton}
            >
              <Icon name={'close'} color={'white'} size={Size.MediumLarge} />
            </Button>
          </div>
          <h1 className={`${styles.title} ${styles.jobTitle}`}>{jobTitle}</h1>

          {totalSteps > 1 && (
            <Wizard currentStep={currentStep} totalSteps={totalSteps} />
          )}
        </div>
      </header>
      
      <ConfirmationModal
        isOpen={isModalOpen}
        title="Are you sure you want to exit this job application?"
        description="Your application will not be submitted to the employer."
        onConfirm={handleExit}
        onClose={() => setIsModalOpen(false)}
        confirmButtonText="Exit"
        confirmButtonUrl={window.Routes.company_job_ad_url(jobCompanyId, jobId)}
        cancelButtonText="Cancel"
      />
    </>
  );
};

export default Header;